import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private config: ConfigService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: { 'grocy-api-key': this.config.config.grocyApiKey },
    });

    return next.handle(authReq);
  }
}
